import React from 'react';
import './BenifitSection.css';

// Import all images
import imgUniversity from '../asset/univer_list-removebg-preview.png';
import imgVisa from '../asset/visa.png';
import imgScholarship from '../asset/scolarship_list-removebg-preview.png';
import imgIntern from '../asset/intern_list-removebg-preview.png';
import imgStudy from '../asset/study_list-removebg-preview.png';
import imgCoaching from '../asset/coaching-removebg-preview.png';

const benefits = [
  {
    image: imgUniversity,
    title: 'World Renowned Universities',
    description: 'Access top global institutions known for academic excellence and internationally recognized degrees.',
  },
  {
    image: imgVisa,
    title: 'Post Study Work Visa',
    description: 'Allows graduates to gain valuable international work experience and kickstart their careers abroad.',
  },
  {
    image: imgScholarship,
    title: 'Easy Available Scholarship',
    description: 'Access a range of scholarships that make studying abroad more affordable and financially feasible.',
  },
  {
    image: imgIntern,
    title: 'Placement & Internship Program',
    description: 'Gain hands-on experience and career opportunities through internships and job placements offered by top international universities.',
  },
  {
    image: imgStudy,
    title: 'Study With or Without IELTS',
    description: "Many universities abroad offer admission options that don't always require IELTS, providing flexible pathways for international students.",
  },
  {
    image: imgCoaching,
    title: 'Free IELTS Coaching Classes',
    description: 'Get complimentary IELTS training to boost your exam scores and meet language requirements for studying abroad.',
  },
];

const BenefitSection = () => {
  return (
    <div className="benefits-container">
      <div className="benefits-header Darkerr">
        <h1>
          Benefits Of Studying Abroad With <b>Zenito Ventures</b>
        </h1>
      </div>

      {benefits.map((item, index) => (
        <div className="benefit-item" key={index}>
          <div className="benefit-icon">
            <img src={item.image} alt="icon" />
          </div>
          <div className="benefit-content">
            <h2>{item.title}</h2>
            <p>{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BenefitSection;
